import React from 'react'
import { useStyle } from '../style'
import { Grid, Typography } from '@mui/material'
import BarcodeTable from './barcodeTable'
import { Helmet } from 'react-helmet-async'

const BarCode = () => {
    const classes = useStyle()

  return (
  <Grid className={classes.root}>
    <Helmet><title>Barcode</title></Helmet>
    <Grid className={classes.titleInfo}>
    <Typography variant="h5" fontWeight={600}>Barcode</Typography>
    </Grid>
    <Grid className={classes.contentGrid}>
        <BarcodeTable />
    </Grid>
  </Grid>
  )
}

export default BarCode